import React from 'react';
import { motion } from 'framer-motion';
import { useScrollReveal } from '../hooks/useScrollReveal';
export function FinalCTA() {
  const {
    ref,
    isVisible
  } = useScrollReveal({
    threshold: 0.3
  });
  return <section className="min-h-screen bg-richBlack flex items-center justify-center relative overflow-hidden border-t border-white/5" data-id="element-36">
      {/* Cinematic dark gradient */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_bottom,_var(--tw-gradient-stops))] from-gold/10 via-richBlack to-richBlack" data-id="element-37" />

      <div className="max-w-4xl mx-auto px-6 text-center relative z-10" data-id="element-38">
        <motion.div ref={ref} initial={{
        opacity: 0,
        y: 40
      }} animate={isVisible ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 1.2,
        ease: [0.16, 1, 0.3, 1]
      }} className="flex flex-col items-center" data-id="element-39">
          <h2 className="font-montserrat font-bold text-3xl md:text-7xl lg:text-8xl text-warmWhite mb-8 md:mb-12 tracking-wide" data-id="element-40">
            Comienza tu transformación hoy.
          </h2>

          <a href="https://cdn.shopify.com/s/files/1/0986/1880/2465/files/No-Naciste-para-una-Vida-Ordinaria-2.pdf?v=1780451854" target="_blank" rel="noopener noreferrer" download className="inline-block w-full sm:w-auto text-center px-10 py-5 bg-gold text-richBlack font-montserrat font-semibold tracking-widest uppercase text-sm hover:bg-goldLight hover:scale-105 transition-all duration-500 shadow-[0_0_40px_rgba(201,168,76,0.2)] hover:shadow-[0_0_60px_rgba(212,175,55,0.4)]" data-id="element-41">
            Descargar guía gratuita
          </a>
        </motion.div>
      </div>

      {/* Footer minimal */}
      <div className="absolute bottom-8 left-0 right-0 text-center" data-id="element-42"></div>
    </section>;
}